import type { TimeEntry } from "@pentacode/core";
import { hour } from "@pentacode/core";
import type { Hours } from "@pentacode/openapi";

export function getEarliestCheckIn(timeEntry: TimeEntry, checkinWindow: Hours) {
    if (!timeEntry.startPlanned && !timeEntry.startFinal) {
        //shifts with flexible start (open-open, open-XX:YY) have to be started on the same day
        return new Date(timeEntry.date);
    }

    return new Date(timeEntry.start.getTime() - checkinWindow * hour);
}
